import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/domain-validation.svg'


const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "breadcrumb-voucher py-3" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = { class: "row pt-5" }
const _hoisted_9 = { class: "col-12 col-lg-7 d-flex flex-column justify-content-start" }
const _hoisted_10 = { class: "text-start fs-6" }
const _hoisted_11 = { class: "text-start mb-4" }
const _hoisted_12 = { class: "w-100 d-flex gap-3" }
const _hoisted_13 = { class: "gray-space-with-border mb-2 flex-grow-1" }
const _hoisted_14 = { class: "text" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "w-100 d-flex gap-3" }
const _hoisted_17 = { class: "gray-space-with-border flex-grow-1" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "text-start mb-4" }
const _hoisted_21 = { class: "w-100 d-flex gap-3" }
const _hoisted_22 = { class: "gray-space-with-border mb-2 flex-grow-1" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = { class: "text-start mb-4" }
const _hoisted_26 = {
  class: "alert alert-dismissible alert-warning",
  role: "alert"
}
const _hoisted_27 = { class: "alert__icon" }
const _hoisted_28 = {
  class: "alert alert-dismissible",
  role: "alert"
}
const _hoisted_29 = { class: "alert__icon" }
const _hoisted_30 = { class: "d-flex flex-column gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_ModalNotPropagated = _resolveComponent("ModalNotPropagated")!
  const _component_ModalSuccessValidationDNS = _resolveComponent("ModalSuccessValidationDNS")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "color--info",
                  name: "house"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "color--info",
              to: "/"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" Emissão de Certificado ")
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "color--primary disabled fw-600",
              to: "/"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode(" Certificado SSL ")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_Wizzard, { "current-page": "alldone" }),
    _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "w-100 fw-600 text-start mt-5" }, " Pra terminar, vamos validar seu domínio ", -1)),
    _createElementVNode("div", _hoisted_8, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "d-none d-lg-block col-lg-5 d-flex justify-content-center" }, [
        _createElementVNode("img", {
          id: "domain-validation-image",
          src: _imports_0,
          alt: "domain-validation"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_link, {
          to: "/domain-validation/validation",
          class: "text-start text link-info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, { name: "angle-left" }),
            _cache[9] || (_cache[9] = _createTextVNode(" Escolher outro tipo de validação "))
          ]),
          _: 1
        }),
        _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "fs-5 fw-400 text-start mt-3 mb-4" }, " Validação de domínio com Registro CNAME no DNS ", -1)),
        _createElementVNode("p", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("strong", null, "Domínio:", -1)),
          _createTextVNode(" www." + _toDisplayString(_ctx.domain), 1)
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-start" }, " Para completar a validação de controle de domínio para este certificado, siga as instruções abaixo: ", -1)),
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-start" }, " 1. Crie um registro CNAME em seu provedor de DNS com as informações abaixo ", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "gray-space-with-border-title me-1" }, "Host:", -1)),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.host), 1)
              ])
            ]),
            _createVNode(_component_Icon, {
              id: "copy-host-icon",
              name: "copy",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.host, 'host'))),
              onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetContent('host')))
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "gray-space-with-border-title me-1" }, "Target:", -1)),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.target), 1)
              ])
            ]),
            _createVNode(_component_Icon, {
              id: "copy-target-icon",
              name: "copy",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyToClipboard(_ctx.target, 'target'))),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetContent('target')))
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-start" }, [
            _createTextVNode(" 2. "),
            _createElementVNode("a", {
              href: "https://toolbox.googleapps.com/apps/dig/",
              target: "blank",
              class: "link-info"
            }, "Clique aqui"),
            _createTextVNode(" para verificar se o CNAME foi adicionado corretamente ")
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "gray-space-with-border-title me-1" }, "Insira:", -1)),
                _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.insertValue), 1)
              ])
            ]),
            _createVNode(_component_Icon, {
              id: "copy-insert-icon",
              name: "copy",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyToClipboard(_ctx.insertValue, 'insert'))),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetContent('insert')))
            })
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "gray-space pt-3" }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", { class: "text" }, "Clique na opção CNAME"),
              _createElementVNode("li", { class: "text" }, " Você deve ver a chave Target se tudo estiver correto ")
            ])
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-start" }, " 3. Após finalizar os passos acima, clique no botão abaixo para iniciar a validação do domínio. ", -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Icon, { name: "circle-exclamation" })
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "alert__content" }, [
              _createElementVNode("span", { class: "text" }, " Importante: Verifique o tempo médio de propagação das alterações realizadas no seu gerenciador de domínio. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_Icon, { name: "lightbulb" })
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "alert__content" }, [
              _createElementVNode("span", { class: "text" }, " Após iniciar a validação do domínio você poderá consultar o andamento mais tarde clicando no link que te enviamos por e-mail! "),
              _createElementVNode("p", { class: "alert-second-text mb-0 mt-3" }, " Depois que o domínio estiver validado, você poderá remover o registro CNAME do seu DNS! ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              id: "validate-domain-button",
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleCheckSolicitationAndDomain && _ctx.handleCheckSolicitationAndDomain(...args)))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "me-2" }, "Validar domínio", -1)),
              _createVNode(_component_Icon, { name: "globe" })
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Contact),
    _createVNode(_component_ModalNotPropagated, { ref: "modalNotPropagated" }, null, 512),
    _createVNode(_component_ModalSuccessValidationDNS, { ref: "ModalSuccessValidationDNS" }, null, 512)
  ]))
}